// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1mnOT","info":"PatientInfo_info__3GvdL"};